export default {
  computed: {
    artists () {
      return this.$store.getters.artists
    },

    artistsLoading: {
      get () {
        return this.$store.getters.artistsLoading
      }
    },
    artistsTotal: {
      get () {
        return parseInt(this.$store.getters.artistsTotal);
      }
    },
    is_empty_filters: {
      get () {
        return this.$store.getters.is_empty_filters
      }
    },

  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/ArtistsComputedMix.js
// module id = null
// module chunks = 